export default __webpack_public_path__ + "static/media/http-request.7ba2478f.png";